export const modalText = {
    deleteNodeTitle: "Delete Node",
    deleteNodeMessage: "Are you sure you want to delete this node? This action cannot be undone.",
    deleteNodeActionName: "Delete",
    deleteVaultItemTitle: "Delete Vault Item",
    deleteVaultItemMessage: "Are you sure you want to delete this vault item? This action cannot be undone.",
    deleteVaultItemActionName: "Delete",
    overwriteDataClassTitle: "Overwrite Schema",
    overwriteDataClassMessage: "Are you sure you want to overwrite this schema? This action cannot be undone.",
    overwriteDataClassActionName: "Overwrite"
}